import { Component, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Observable } from 'rxjs';
//import { ServiceService } from '@app/core/services/ServiceService';
import { AuthenticationService } from '@app/core/services/AuthenticationService'
import { ICompany } from '@app/core/interfaces/ICompany';
import { IContact } from '@app/core/interfaces/IContact';
//import { InvoiceService } from '@app/core/services/InvoiceService';
import { CompanyService } from '@app/core/services/CompanyService';

@Component({
  standalone: false,
  styleUrls: ['modal-spinner-dialog.component.scss'],
    selector: 'modal-spinner-dialog',
    template: `

<mat-dialog-content class="modal-spinner-dialog-content">

<div class="spinner-container">
<mat-spinner [diameter]="100" color="accent"></mat-spinner>
</div>
<span class="content">Vänta medan vi hämtar din information</span>
</mat-dialog-content>

`
})


export class ModalSpinnerDialogComponent {
    private _dimesionToggle = false;
    private _formValid = false;
    public _imageList: any[] = [];
    public _hasImages = false;
    private _showImageList = false;
    private _showAttachments = false;
    private _hasAttachments = false;
    private _showComments = false;
    public contact: IContact;
    private companyId: number;
    public isNew: boolean;
    @ViewChild('myInput', { static: false })
    myInputVariable: any;
    private _apiBaseUrl: string;
        
    constructor(
      public dialogRef: MatDialogRef<ModalSpinnerDialogComponent>,
        //private service: ServiceService,
        private authenticationService: AuthenticationService,
        //private invoiceService: InvoiceService,
        private companyService: CompanyService,
        //private config: AppConfig,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) 
    { 
        //this._apiBaseUrl = config.getConfig('host');
    }

    ngOnInit() {
        
        
    }

    
    
}



